.vc-chatbar-button {
    display: flex;
    align-items: center;
}
